<template>
  <modal :center="false" :show="visible" modalClasses="modal-lg">
    <h3 class="text-center">
      Cập nhật trạng thái
    </h3>
    <block ref="bmdal">
      <ValidationObserver ref="csInfo" v-slot="{ handleSubmit }">
        <form role="form" @submit.prevent="handleSubmit">
          <b-row>
            <b-col sm="6" xs="12">
              <!-- <ValidationProvider
                name="Số lượng đã sản xuất"
                rules="required"
                v-slot="{ errors }"
              >
                <base-input
                  :mask="'number'"
                  label="Số lượng đã sản xuất"
                  :error="errors[0]"
                  v-model="info.quantityProduce"
                  :valid="errors.length == 0"
                ></base-input>
              </ValidationProvider> -->
              <base-input
                :mask="'number'"
                :label="`Số lượng đã sản xuất - ĐVT :${info.unit}`"
                v-model="info.quantityProduce"
              ></base-input>
            </b-col>
            <b-col sm="6" xs="12">
              <div class="form-group m-0 has-label has-success">
                <label class="form-control-label">
                  Trạng thái
                </label>
                <b-form-select
                  class="form-control"
                  v-model="info.status"
                  :options="optionStatus"
                ></b-form-select>
              </div>
            </b-col>
          </b-row>
        </form>
        <hr />
        <b-row>
          <b-col sm="6" xs="12" md="4">
            <b-button class="mb-2" block variant="success" @click="doSave(1)">
              Lưu tiếp (Shift + F4)
            </b-button>
          </b-col>
          <b-col sm="6" xs="12" md="4">
            <b-button
              class="mb-2"
              type="submit"
              block
              variant="dark"
              @click="doSave(0)"
            >
              Lưu đóng (F4)
            </b-button>
          </b-col>
          <b-col sm="12" md="4">
            <b-button
              class="mb-2"
              block
              variant="secondary"
              @click="handleClose"
            >
              Đóng (Esc)
            </b-button>
          </b-col>
        </b-row>
      </ValidationObserver>
    </block>
    <event
      @doCancel="handleClose"
      @doSave="doSave(0)"
      @doSaveContinue="doSave(1)"
    ></event>
  </modal>
</template>
<script>
import { manufactureService } from "@/_services";
export default {
  props: {},
  data() {
    return {
      visible: false,
      info: {},
      ownInfo: {},
      optionStatus: [
        { value: 0, text: "Chưa xác nhận" },
        { value: 1, text: "Đang sản xuất" },
        { value: 2, text: "Đã đủ hàng" },
        { value: 3, text: "Đã xuất hàng" }
      ]
    };
  },
  methods: {
    doSave: function(type) {
      var self = this;
      if (!this.visible) return;
      this.$refs.csInfo.validate().then(success => {
        if (!success) return;
        this.$refs.bmdal.block();
        if (self.info.id) {
          manufactureService
            .status(self.info.id, self.info.status, self.info.quantityProduce)
            .then(res => {
              if (type == 0) {
                self.visible = false;
              }
              self.ownInfo.status = self.info.status;
              self.ownInfo.quantityProduce = self.info.quantityProduce;
              this.$alertify.success(res.message, {
                duration: 4000
              });
            })
            .catch(err => {
              if (err.data) {
                err.data.forEach(element => {
                  let errObj = {};
                  errObj[element.context.key] = [element.message];
                  self.refs.csInfo.setErrors(errObj);
                });
              }
            })
            .finally(() => {
              this.$refs.bmdal.unBlock();
            });
        }
      });
    },
    setData(info) {
      info.status = Number(info.status);
      this.ownInfo = info;
      this.info = Object.assign({}, info);
    },
    handleClose() {
      this.visible = false;
    }
  }
};
</script>
<style lang="scss"></style>
